import React from 'react';
import { motion } from 'framer-motion';
import {
  Box,
  VStack,
  HStack,
  Text
} from '@chakra-ui/react';
import { MdPerson, MdWork, MdCelebration, MdBusinessCenter, MdSportsBasketball, MdCheckroom, MdArrowForward, MdCameraAlt } from 'react-icons/md';

const ChatWelcome = ({ onExampleClick, style = 'women', onPhotoUpload }) => {
  const examplePrompts = style === 'women' ? [
    { icon: MdPerson, text: 'Casual dresses for Saturday brunch' },
    { icon: MdWork, text: 'Work blazers under $150' },
    { icon: MdCelebration, text: 'Weekend party night outfit ideas' }
  ] : [
    { icon: MdBusinessCenter, text: 'Business casual shirts for work' },
    { icon: MdSportsBasketball, text: 'Casual sneakers under $200' },
    { icon: MdCheckroom, text: 'Weekend jacket for fall weather' }
  ];

  return (
    <Box px={0} py={0}>
      

      {/* Example Prompts Section */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        <Box 
          w="100%" 
          className="bg-gradient-to-br from-white to-stone-50 border border-stone-200 rounded-2xl shadow-lg"
          p={{ base: 6, md: 8 }}
        >

          <VStack spacing={4} align="stretch">
            {examplePrompts.map((prompt, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.3 + (index * 0.1) }}
                whileHover={{ scale: 1.02, y: -2 }}
                whileTap={{ scale: 0.98 }}
              >
                <Box
                  onClick={() => onExampleClick(prompt.text)}
                  cursor="pointer"
                  className="relative bg-gradient-to-br from-stone-50 to-stone-100 border border-stone-300 hover:from-stone-100 hover:to-stone-200 rounded-2xl p-4 transition-all duration-400"
                  position="relative"
                  boxShadow="0 4px 16px rgba(139, 115, 85, 0.08)"
                  _hover={{
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 24px rgba(139, 115, 85, 0.12)',
                    borderColor: '#d4a574'
                  }}
                  _before={{
                    content: '""',
                    position: 'absolute',
                    top: '0.5rem',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '30px',
                    height: '1px',
                    background: 'linear-gradient(90deg, transparent, #d4a574, transparent)'
                  }}
                >
                  <HStack spacing={3} align="center">
                    <Box
                      className="bg-gradient-to-br from-stone-100 to-stone-200 rounded-xl p-3 flex-shrink-0"
                      minW="48px"
                      h="48px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      boxShadow="0 2px 8px rgba(139, 115, 85, 0.15)"
                    >
                      <prompt.icon size={22} color="#d4a574" />
                    </Box>
                    <Box flex={1}>
                      <Text 
                        fontWeight="medium"
                        className="text-stone-800"
                        fontSize="sm"
                        lineHeight="shorter"
                        letterSpacing="wide"
                      >
                        {prompt.text}
                      </Text>
                    </Box>
                    <Box color="#d4a574">
                      <MdArrowForward size={20} />
                    </Box>
                  </HStack>
                </Box>
              </motion.div>
            ))}
          </VStack>

          {/* Premium Photo Upload Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.8 }}
            className="mt-6"
          >
            <Box
              onClick={onPhotoUpload}
              cursor="pointer"
              className="relative bg-gradient-to-br from-stone-50 to-stone-100 border border-stone-300 rounded-2xl transition-all duration-400 hover:from-stone-100 hover:to-stone-200 hover:border-yellow-600"
              minH={{ base: "160px", md: "200px" }}
              p={{ base: "1.5rem 1rem", md: "2rem 1.5rem" }}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              textAlign="center"
              position="relative"
              boxShadow="0 4px 16px rgba(139, 115, 85, 0.08)"
              _hover={{
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 24px rgba(139, 115, 85, 0.12)'
              }}
              _before={{
                content: '""',
                position: 'absolute',
                top: { base: '0.75rem', md: '1rem' },
                left: '50%',
                transform: 'translateX(-50%)',
                width: { base: '30px', md: '40px' },
                height: '1px',
                background: 'linear-gradient(90deg, transparent, #d4a574, transparent)'
              }}
            >

              {/* Camera Icon */}
              <Box mb={5} fontSize={{ base: "32px", md: "40px" }}>
                <MdCameraAlt color="#d4a574" />
              </Box>


              {/* Subtitle */}
              <Text
                fontSize={{ base: "md", md: "lg" }}
                fontWeight="bold"
                className="text-stone-600"
                mb={4}
              >
                Upload a photo to get styling suggestions
              </Text>

              {/* Description */}
              <Text
                fontSize={{ base: "md", md: "lg" }}
                className="text-stone-500"
                fontStyle="italic"
                lineHeight="1.4"
                maxW={{ base: "180px", md: "200px" }}
              >
                Your outfit, a piece you love, or style inspiration
              </Text>
            </Box>
          </motion.div>

        </Box>
      </motion.div>

    </Box>
  );
};

export default ChatWelcome;